"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductDetailsModal = void 0;
const react_1 = require("react");
/**
 * Controls the state of single product details modal
 */
const useProductDetailsModal = (props) => {
    const { productIds } = props || {};
    const [productIdForDetailsModal, setProductIdForDetailsModal] = (0, react_1.useState)(null);
    const activeProductIds = productIds.findIndex((id) => id === productIdForDetailsModal);
    const handleNextClick = (0, react_1.useCallback)(() => {
        if (activeProductIds < productIds.length - 1) {
            setProductIdForDetailsModal(productIds[activeProductIds + 1]);
        }
        else {
            setProductIdForDetailsModal(productIds[0]);
        }
    }, [activeProductIds, productIds]);
    const handlePreviousClick = (0, react_1.useCallback)(() => {
        if (activeProductIds > 0) {
            setProductIdForDetailsModal(productIds[activeProductIds - 1]);
        }
        else {
            setProductIdForDetailsModal(productIds[productIds.length - 1]);
        }
    }, [activeProductIds, productIds]);
    const onClose = (0, react_1.useCallback)(() => {
        setProductIdForDetailsModal(null);
    }, []);
    return {
        productIdForDetailsModal,
        setProductIdForDetailsModal,
        productDetailsModalProps: {
            selectedProductId: productIdForDetailsModal,
            onClose,
            onNext: handleNextClick,
            onPrevious: handlePreviousClick,
        },
    };
};
exports.useProductDetailsModal = useProductDetailsModal;
